import axios from 'axios';
import Tone from 'tone';
import ipfsClient from 'decentralized/Ipfs';
import ethereum from 'decentralized/ethereum.js';

class SoundUploader {
    constructor(numChannels, onSoundUploaded) {
        this.onSoundUploaded = onSoundUploaded;
        this.numChannels = numChannels;
        this.soundIdCounter = 0;
    }

    exportToWAV(buffer, callback) {
        var fd = new FormData();
        var self = this;
        
        // start a new worker 
        // we can't use Recorder directly, since it doesn't support what we're trying to do
        var worker = new Worker(window.isNFT ? 'recorderWorker.js' : '/recorderWorker.js');
        
        // initialize the new worker
        worker.postMessage({
                command: 'init',
                    config: {sampleRate: Tone.context.sampleRate,
                        numChannels: this.numChannels}
            });
        
        
        // callback for `exportWAV`
        worker.onmessage = function( e ) {
            var blob = e.data;
            var arrayBuffer;
            var fileReader = new FileReader();
            fileReader.onload = function() {
                arrayBuffer = this.result;
                callback(new Buffer(arrayBuffer));
            };
            fileReader.readAsArrayBuffer(blob);

       };
        
        // send the channel data from our buffer to the worker
        worker.postMessage({
                command: 'record',
                    buffer: buffer
                    });
        
        // ask the worker for a WAV
        worker.postMessage({
                command: 'exportWAV',
                    type: 'audio/wav'
                    });
    
    }

    uploadBufferToIpfs(buffer, asIs=false, id, filename) {
        return new Promise((resolve, reject) => {
            var fd = new FormData();
            var self = this;
            
            // start a new worker 
            // we can't use Recorder directly, since it doesn't support what we're trying to do
            var worker = new Worker(window.isNFT ? 'recorderWorker.js' : '/recorderWorker.js');

            // initialize the new worker
            worker.postMessage({
                command: 'init',
                config: {sampleRate: Tone.context.sampleRate,
                         numChannels: this.numChannels}
            });
            
            var name = 'sampled at ' + new Date();
            // callback for `exportWAV`
            worker.onmessage = function( e ) {
                var blob = e.data;
                ipfsClient.addBlob(blob, filename)
                    .then((ipfsHash) => {
                        if (asIs) {
                            self.onSoundUploaded(this.soundIdCounter++, ipfsHash, id);
                        }
                        resolve(ipfsHash);
                    });
            };
            
            // send the channel data from our buffer to the worker
            if (asIs) {
                worker.postMessage({
                    command: 'record',
                    buffer: buffer
                });
            } else {
                let bufferToSend = [];
                for (let i=0; i < buffer.numberOfChannels; i++) {
                    bufferToSend.push(buffer.getChannelData(i));
                }
                worker.postMessage({
                    command: 'record',
                    buffer: bufferToSend
                });
            }
            
            // ask the worker for a WAV
            worker.postMessage({
                command: 'exportWAV',
                type: 'audio/wav'
            });
        });
    }

    uploadVideoBlob(buffer, videoId, startTime, endTime, id, decentralized=false) {
        var fd = new FormData();
        var self = this;
        
        // start a new worker 
        // we can't use Recorder directly, since it doesn't support what we're trying to do
        var worker = new Worker(window.isNFT ? 'recorderWorker.js' : '/recorderWorker.js');
        
        // initialize the new worker
        worker.postMessage({
                command: 'init',
                    config: {sampleRate: Tone.context.sampleRate,
                        numChannels: this.numChannels}
            });
        
        var name = 'sampled at ' + new Date();
        // callback for `exportWAV`
        worker.onmessage = function( e ) {
            var blob = e.data;
            ipfsClient.addBlob(blob)
                .then((ipfsHash) => {
                    if (decentralized) {
                        self.onSoundUploaded(undefined, ipfsHash, id);
                        return;
                    }
                    //ethereum.saveSample(ipfsHash[0].hash, videoId);
                    self.onSoundUploaded(id, ipfsHash, id);
        
                });
        };
        
        // send the channel data from our buffer to the worker
        worker.postMessage({
                command: 'record',
                    buffer: buffer
                    });
        
        // ask the worker for a WAV
        worker.postMessage({
                command: 'exportWAV',
                    type: 'audio/wav'
                    });
    
    }
}

export default SoundUploader;
